import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import arrow from '../../../../images/right-arrow.svg';
import { Howl } from 'howler';
import { useTranslation } from 'react-i18next';
import { ChildContext } from '../../Container/displayboardcontext';
import { alertSuspend } from '../../../../store/actions';
import { getTokenPopupTime, getAudioFiles } from '../../../../helpers/helpersIndex';
import * as _ from 'lodash';
import { EStatusEnum } from '../../../../models/utilitiesModel';

let interval;

const ThemeOnePopupAlert: React.FC = () => {

    // const audio = new Audio();
    // const audioPath = `assets/audio/${getAudioFiles('theme1')}`;
    const dispatch = useDispatch();
    const context = useContext(ChildContext)?.alertData;
    const audioPath = useContext(ChildContext)?.audioPath;
    const { t } = useTranslation("translations");
    const isDisplayBoardActive: boolean = useSelector((state: any) => state.displayBoardReducer?.isDisplayBoardActive === EStatusEnum.NACTIVE)



    // audio.src = audioPath;
    let sound: Howl = new Howl({
        src: [audioPath]
    });
    // audio.load();

    const replayAudio = () => {
        sound.currentTime = 0;
        sound.pause();
        sound.play();
    }

    // const playAudio = () => {
    //     try {
    //         audio.currentTime = 0;
    //         audio.pause();
    //         const playPromise = audio.play();
    //         if (playPromise !== null && playPromise) {
    //             playPromise.catch(e => {
    //                 console.log('error=>1', e);
    //                 replayAudio();
    //             })
    //         }
    //         else
    //             replayAudio();
    //     }
    //     catch (e) {
    //         console.log('error=>', e);
    //         replayAudio();
    //     }
    // }
    // playAudio();

    useEffect(() => {
        // replayAudio();
        interval = setTimeout(() => {
            dispatch(alertSuspend());
        }, 1000 * getTokenPopupTime());

        return () => {
            if (interval)
                clearTimeout(interval);
            // audio?.pause();
            // if (sound) {
            //     sound.off();
            //     sound.stop();
            // }
        }
    });

    return (
        <>
            <Modal className="mtknModalSignage modal-lg modal-dialog-centered" isOpen={isDisplayBoardActive}>
                <ModalBody>
                    <audio autoPlay>
                        <source type="audio/wav" src={audioPath} />
                    </audio>
                    <div className="mtknModalBody">
                        <Row className="align-items-center">
                            <div className="mtokenlabel">
                                <div className='text_arabic'>{t('DisplayBoard.tokenNumberArb')}</div>
                                <div>{t('DisplayBoard.tokenNumber')}</div>
                            </div>
                            <Col>
                                <div className="mtokendetails">{context.tokenNo}</div>
                            </Col>
                        </Row>
                        <hr />
                        <Row className="align-items-center">
                            <div className="mtokenlabel">
                                <div className='text_arabic'>{t('DisplayBoard.counterNumberArb')}</div>
                                <div>{t('DisplayBoard.counterNumber')}</div>
                            </div>
                            <Col>
                                <div className="mtokendetails roomNumber">{context.roomMasterEngName} : {context.roomNo}</div>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}
export default React.memo(ThemeOnePopupAlert);